<script>
   import Button from "@smui/button";
   import AttemptsTable from "./AttemptsTable.svelte";

   export let idToken = null;
   export let viewingClass = null;
   export let searchParams = null;

   export let isAdmin = false;
   export let inviteNotifAnchor = "classDashboardInvite";
   export let reminderNotifAnchor = "classDashboardReminder";

   export let setTaskNotif = () => 0;

   let selectedCount = 0;
   let selectedKeys = [];
   let allSelCb;
   let allSelected = false;

   let pendingSelectedCount = 0;
   let pendingSelectedKeys = [];
   let allSelCbPd;
   let pendingAllSelected = false;

   let currentViewData = null;

   let addStudentsField = "";
   let doMailField = false;

   let expiryType = 'unuse';
   let expiryVal = 10;
   let expiryDenom = 'minutes';

   let codeExpired = false;


   const msPerDay = 24 * 60 * 60000;

   const dateNow = new Date();
   const tDeltaZone = dateNow.getTimezoneOffset() * 60000;

   const tNowLocal = dateNow.getTime() - tDeltaZone;
   const tTomorrowLocal = tNowLocal + msPerDay;
   const tThreeMonthsLocal = tNowLocal + (90*msPerDay);

   const dateTomorrow = new Date(tTomorrowLocal);
   const dateThreeMonths = new Date(tThreeMonthsLocal);


   function makeInviteCodeParameters() {
      let exVal;
      if(expiryType === 'date') {
         exVal = new Date(expiryVal).toISOString().slice(0, -8);
      }
      else {
         exVal = {};
         exVal[expiryDenom] = expiryVal;
      }

      return {
         expiry_mode: expiryType,
         expiry_val: exVal
      };
   }

   function formatSecondsCount(s) {
      const readout = [];
      if(s >= 86400) {
         const dC = Math.floor(s / 86400);
         readout.push(`${dC} day${dC > 1? "s":""}`);
         s %= 86400;
      }
      if(s >= 3600) {
         const hC = Math.floor(s / 3600);
         readout.push(`${hC} hour${hC > 1? "s":""}`);
         s %= 3600;
      }
      if(s >= 60) {
         const mC = Math.floor(s / 60);
         readout.push(`${mC} minute${mC > 1? "s":""}`);
         s %= 60;
      }
      if(s >= 1) {
         const sC = Math.floor(s);
         readout.push(`${sC} second${sC > 1? "s":""}`);
      }
      return readout.join(', ');
   }

   function codeCopyHandler(invCode) {
      return async () => {
         try {
            await navigator.clipboard.writeText(invCode);
            alert("Code copied to clipboard!");
         } catch (err) {
            alert(`Failed to copy code: ${err}`);
         }
      }
   }

   function toggleAllJoined() {
      const newSelectState = !allSelected;
      for(let sKeys of Object.keys(currentViewData.students_data)) {
         currentViewData.students_data[sKeys].selected = newSelectState;
      }
   }

   function toggleAllPending() {
      const newSelectState = !pendingAllSelected;
      for(let pIdx in currentViewData.pending_students) {
         currentViewData.pendingSelectOptions[pIdx] = newSelectState;
      }
   }

   $: {
      if(currentViewData && 'students_data' in currentViewData) {
         selectedKeys = [];
         selectedCount = 0;
         for(let [sKey, sData] of Object.entries(currentViewData.students_data)) {
            if(sData.selected) {
               selectedCount++;
               selectedKeys.push(sKey);
            }
         }
         allSelected = selectedCount === Object.keys(currentViewData.students_data).length;
         if(allSelCb) {
             allSelCb.checked = allSelected;
             allSelCb.indeterminate = selectedCount > 0 && !allSelected;
         }

         if(!currentViewData.is_trial) {
            pendingSelectedKeys = [];
            pendingSelectedCount = 0;
            for(let pIdx in currentViewData.pending_students) {
               if(currentViewData.pendingSelectOptions[pIdx]) {
                  pendingSelectedCount++;
                  pendingSelectedKeys.push(currentViewData.pending_students[pIdx]);
               }
            }
            pendingAllSelected = pendingSelectedCount === currentViewData.pending_students.length;
            if(allSelCbPd) {
               allSelCbPd.checked = pendingAllSelected;
               allSelCbPd.indeterminate = pendingSelectedCount > 0 && !pendingAllSelected;
            }
         }
      }
   }


   function postTaskAndRefresh(route, body={}, conf=null, newLoc=null) {
      return async () => {
         if(conf) {
            const confRes = conf();
            if(!confRes) return;

            for(let [k, v] of Object.entries(confRes)) {
               body[k] = v;
            }
         }

         body['class_id'] = viewingClass;

         console.log(body);

         await new Promise(r => r(idToken)).then((tok) => {
            const headers = new Headers();
            headers.append('Authorization', tok);
            headers.append('Content-Type', "application/json");

            return fetch(`/api/${route}`, {method: 'POST', headers: headers, body: JSON.stringify(body)}).then(res => {
               if(!res.ok) {
                  return res.text().then(tx => {
                     alert(
`We're sorry, an error occurred while performing the task.

${tx}`
                     );
                     return null;
                  });
               }
               return res.json();
            });
         }).then((data) => {
            if(data) {
               if('notification' in data) {
                  alert(data.notification);
               }
               if(newLoc){
                  location.href = newLoc;
               }
               else {
                  if(!(newLoc === false)) {
                     location.reload();
                  }
               }
            }
         }).catch(err => {
            alert(
`We're sorry, our system has encountered an unexpected error.
${err}

Please try again later.`
            );
         });
      }
   }

   function mailTaskAndRefresh(
      route, addrs={student_addresses: []}, conf=null, successMessage="Task completed.",
      etcBody={}, notifAnchor=inviteNotifAnchor, newLoc=null
   ) {
      // Argument will recieve the "revised addresses" element ID field to pull from as required
      const taskProcess = async (retryAddrsField) => {
         const addrsKey = Object.keys(addrs)[0];

         if(retryAddrsField) {
            const addrsElm = document.getElementById(retryAddrsField);
            etcBody[addrsKey] = addrsElm.value.toLowerCase();
         }
         else {
            if(Array.isArray(Object.values(addrs)[0])) {
               etcBody[addrsKey] = Object.values(addrs)[0];
            }
            else {
               etcBody[addrsKey] = Object.values(addrs)[0].toLowerCase();
            }
         }

         if(conf) {
            const confRes = conf(etcBody[addrsKey].length);
            if(!confRes) return;

            for(let [k, v] of Object.entries(confRes)) {
               etcBody[k] = v;
            }
         }

         etcBody['class_id'] = viewingClass;

         console.log(etcBody);

         await new Promise(r => r(idToken)).then((tok) => {
            const headers = new Headers();
            headers.append('Authorization', tok);
            headers.append('Content-Type', "application/json");

            return fetch(`/api/${route}`, {method: 'POST', headers: headers, body: JSON.stringify(etcBody)}).then(res => {
               const ct = res.headers.get('Content-Type');
               if(ct && ct.includes('application/json')) {
                  return res.json();
               }

               return res.text();
            }).then(data => {
               if(typeof data !== 'string' && 'result' in data) {
                  const res = data['result'];

                  if(res === 'OK') {
                     setTaskNotif('TASKSUCCESS', [`<INFO>${successMessage}`], notifAnchor);
                     new Promise(r => setTimeout(r, 3000)).then(() => {
                        if(newLoc){
                           location.href = newLoc;
                        }
                        else {
                           if(!(newLoc === false)) {
                              location.reload();
                           }
                        }
                     });
                     return;
                  }

                  if('recipients' in data) {
                     // Creation stopped because bad mail result
                     const msgs = 'messages' in data && data.messages.length > 0? data.messages : undefined;
                     setTaskNotif(res, msgs, notifAnchor,
                        'recipients' in data? data.recipients : [],
                        'recipients_cc' in data? data.recipients_cc : [],
                        'recipients_bcc' in data? data.recipients_bcc : [],
                        taskProcess
                     );
                     return;
                  }

                  // Unexpected
                  window.alert(
`We're sorry, our system has encountered an unexpected error.
${res}

Please try again later.`
                  );
               }
               else {
                  // Creation stopped because of auth or request issue
                  setTaskNotif(
                     'TASKERROR',
                     [`<KILL>${typeof data === 'string'? data : JSON.stringify(data)}`],
                     notifAnchor
                  );
               }
            });
         });
      }

      // Ensure default event arguments are never passed on first attempt
      return () => {taskProcess();}
   }

   async function dataDump(research=false) {
      const a = document.getElementById("csvDownloadLink");
      a.href = "";
      a.download = `${research? "RESEARCH-ONLY_" : ""}AttemptsData_${
         currentViewData.class_name.replace(/[^a-z0-9]/gi, '-')
      }_${currentViewData.is_trial? "Trial" : ""}Classroom${viewingClass}.csv`;

      const csvButton1 = document.getElementById("teachingDL");
      const csvButton2 = document.getElementById("researchDL");

      csvButton1.disabled = true;
      if(csvButton2) {
         csvButton2.disabled = true;
      }

      await new Promise(r => r(idToken)).then( (tok) => {
         const headers = new Headers();
         headers.append('Authorization', tok);
         headers.append('Content-Type', "text/csv");


         return fetch(
            `/api/${research? "research" : "teaching"}/attempts_raw?` + new URLSearchParams({class_id: viewingClass}).toString(),
            {headers: headers}
         ).then(res => {
            if(!res.ok) {
               return res.text().then(tx => {
                  alert(
`Sorry, an error occurred while retrieving the content.

${tx}`
                  );
                  return null;
               });
            }
            return res.blob();
         }).then((csvBlob) => {
            csvButton1.disabled = false;
            if(csvButton2) {
               csvButton2.disabled = false;
            }

            if(csvBlob) {
               a.href = URL.createObjectURL(csvBlob);
               a.click();
            }
         }).catch(err => {
            window.alert(
`Error: Unable to retrieve classroom data.

${err}`
            );

            csvButton1.disabled = false;
            if(csvButton2) {
               csvButton2.disabled = false;
            }
         });
      });
   }

   async function fetchClassData(idTok, clsId) {
      if(!(idTok && clsId)) {
         console.log("Attempt to fetch class data before initialization");
         return null;
      }

      return await new Promise(r => r(idTok)).then( (tok) => {
         const headers = new Headers();
         headers.append('Authorization', tok);
         headers.append('Content-Type', "application/json");

         const pms = {class_id: viewingClass};

         const forceAllAttempts = searchParams.get("getallattempts");
         if(forceAllAttempts) {
            pms['force_all_attempts'] = forceAllAttempts;
         }

         return fetch('/api/teaching/class_details?' + new URLSearchParams(pms).toString(), {headers: headers}).then(res => {
            if(!res.ok) {
               return res.text().then(tx => {
                  alert(
`Sorry, an error occurred while retrieving this content.

${tx}`
                  );
                  return null;
               });
            }
            return res.json();
         }).then(data => {
            if(data) {
               for(let sData of Object.values(data.students_data)) {
                  sData.selected = false;
               }

               if(data.is_trial) {
                  codeExpired = new Date().getTime() > new Date(data.code_expiry).getTime();
               }
               else {
                  data.pendingSelectOptions = Array.from({length: data.pending_students.length}, (v, i) => false);
               }

               console.log(data);

               currentViewData = data;
               return data;
            }

            return null;
         });
      });
   }

   let didHashNav = !Boolean(location.hash);
   async function navToHash() {
      return new Promise(r => setTimeout(r, 250)).then(() => {
         if(location.hash && location.hash.length > 1) {
            const hLoc = location.hash.substring(1);
            console.log("nav to hash: " + hLoc);
            const target = document.getElementById(hLoc);
            if(target) {
               target.scrollIntoView();
               didHashNav = true;
            }
         }
      });
   }

   $: dataPromise = fetchClassData(idToken, viewingClass);

   $: if(currentViewData && !didHashNav) {
        navToHash();
   }

</script>

<div class="box">
    <div style="text-align: left">
        <a href="/" style="display: flex; align-items: center">
            <span>&lt;</span>
            <span style="margin: 0 0.15em" class="material-icons">foundation</span>
            <span>Back to home</span>
        </a>
    </div>
    {#await dataPromise}

        <h2>One Moment...</h2>

    {:then viewData}

        <h2>{viewData.class_name}</h2>
        {#if 'createdAt' in viewData}
            <p>Created: {new Date(viewData.createdAt).toLocaleString()}</p>
        {/if}
        <h3>Student Roster</h3>
        {#if 'students_data' in viewData && Object.keys(viewData.students_data).length > 0}
            <div style="display:flex; align-items: center; justify-content: center">
                <input
                    class="roster-check"
                    type="checkbox"
                    bind:this={allSelCb}
                    on:click={toggleAllJoined}
                />
                Select All
            </div>
            <ul class="roster-list">
            {#each Object.entries(viewData.students_data) as [sKey, sData]}
                <li class:full-details={'all_attempts_retrieved' in sData && sData.all_attempts_retrieved}>
                    <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between">
                        <div>
                            <h4 id={encodeURIComponent(sKey)}>
                                <input class="roster-check" type="checkbox" bind:checked={currentViewData.students_data[sKey].selected}/>
                                {sData['student_name']}
                                {#if !viewData.is_trial}
                                    <a href={`mailto:${sKey}`}>
                                        <button class="email-button"><span class="material-icons">email</span></button>
                                    </a>
                                {/if}
                            </h4>
                            <p>Joined {new Date(sData['join_time']).toLocaleString()}</p>
                        </div>

                        <div>
                            <p>
                                Showing<br>
                                <b>
                                    {sData['attempts'].length} of
                                    {sData['attempts'].length + ('omitted_attempts' in sData? sData.omitted_attempts : 0)}
                                </b><br>
                                attempts to date
                            </p>
                        </div>
                    </div>
                    <div style="flex: 2">
                        <AttemptsTable attempts={sData['attempts']}/>
                    </div>
                </li>
            {/each}
            </ul>
            <h4>Options</h4>
            <p>{selectedCount > 0? selectedCount : "None"} selected...</p>
            <a
                    href={`?${new URLSearchParams({
                        class: viewingClass, getallattempts: allSelected? "*ALLSTUDENTS*" : selectedKeys.join(',')
                    }).toString()}`}
                    style:pointer-events={selectedCount < 1? "none" : "auto"}
            >
                <Button variant="raised" disabled={selectedCount < 1}>
                    <span class="material-icons">read_more</span> Load All Attempts
                </Button>
            </a>
            <Button
                    variant="raised"
                    on:click={postTaskAndRefresh("classes/remove_students", {students: selectedKeys}, () => {
                       if(confirm(`Are you sure you'd like to unenroll ${selectedCount} selected student(s)?`)) {
                          return {remove_confirmation: "REMOVE"};
                       }
                       return false;
                    })}
                    disabled={selectedCount < 1}
            >
                <span class="material-icons">group_remove</span> Unenroll Students
            </Button>
            <Button
                    variant="raised"
                    on:click={postTaskAndRefresh("teaching/clear_attempts", {students: selectedKeys}, () => {
                       const pmtRes = prompt(
`Really delete all teaching data for ${selectedCount} selected student(s)?
This can't be undone!

Enter "CLEAR ALL ATTEMPTS" in the field below to confirm.`
                       );
                       if(pmtRes) {
                          return {clear_attempts_confirmation: pmtRes};
                       }
                       return false;
                    })}
                    disabled={selectedCount < 1}
            >
                <span class="material-icons">delete_outline</span> Clear Data
            </Button>
        {:else}
            <p>Nothing to see here yet!</p>
            <p>See below to get some students added to this class.</p>
        {/if}

        {#if viewData.is_trial}
            <h3>Invite Settings</h3>
            <p>Your current invite code is:</p>
            {#if codeExpired}
                <p class="invite-code-big expired">{viewData.invite_code}</p>
                <p style="color: brown">⚠ This code has expired and can no longer be used.<br>
                    See below to create a new one!</p>

            {:else}
                <p class="invite-code-big">{viewData.invite_code}</p>
                <Button
                        variant="raised"
                        on:click={codeCopyHandler(viewData.invite_code)}
                >
                    <span class="material-icons">content_copy</span> Copy Code
                </Button>
                {#if Boolean(viewData.code_expiry_refresh)}
                    <p>
                        This code expires after
                        {formatSecondsCount(viewData.code_expiry_refresh)}
                        without a new user joining.<br>
                        It is currently set to expire {new Date(viewData.code_expiry).toLocaleString()}.</p>
                {:else}
                    <p>This code will expire {new Date(viewData.code_expiry).toLocaleString()}.</p>
                {/if}

                <h4>Invite via Email</h4>
                <form on:submit|preventDefault={mailTaskAndRefresh(
                   "classes/dispatch_trial_mail", {invite_addresses: addStudentsField}, null, "Invites sent.", {}, inviteNotifAnchor, false
                   )}
                >
                    <label for="trialAddStudentsField">Enter emails to invite (delimited by spaces):</label>
                    <input
                            class="invite-entry"
                            placeholder="e.g. bhoneydew@wpi.edu beaker@gmail.com"
                            id="trialAddStudentsField"
                            bind:value={addStudentsField}
                            type="text"
                            required
                    />
                    <Button type="submit" id="trialAddConf" variant="raised">
                        <span class="material-icons">email</span> Invite users
                    </Button>
                </form>

                <!-- Intended to supply mail result anchor from App -->
                <slot name="mailInvite" />

            {/if}

            <h4>Create New Invite Code</h4>
            <form on:submit|preventDefault={postTaskAndRefresh(
               "classes/new_invite_code", makeInviteCodeParameters(), () => {
                  if(codeExpired || confirm(
                     "Create a new invite code?\n\nThis will invalidate the current code. No student or class data will be affected."
                     )) {
                     return {};
                  }
                  return false;
               })}
            >
                <fieldset style="margin-bottom: 0.5em">
                    <legend>Expire new invite code...</legend>
                    <div style="display: flex; justify-content: space-evenly">
                        <div>
                            <label for="invExpireUnuse">After a duration of unuse</label>
                            <input
                                    type="radio"
                                    id="invExpireUnuse"
                                    on:click={() => {
                                           expiryType = 'unuse';
                                           expiryVal = 10;
                                           expiryDenom = 'minutes';
                                        }}
                                    name="trial-create-expiry"
                                    checked
                            />
                        </div>
                        <div>
                            <label for="invExpireLength">After a specific duration</label>
                            <input
                                    type="radio"
                                    id="invExpireLength"
                                    on:click={() => {
                                           expiryType = 'length';
                                           expiryVal = 10;
                                           expiryDenom = 'minutes';
                                        }}
                                    name="trial-create-expiry"
                            />
                        </div>
                        <div>
                            <label for="invExpireDate">At a set date and time</label>
                            <input
                                    type="radio"
                                    id="invExpireDate"
                                    on:click={() => {
                                           expiryType = 'date';
                                           expiryVal = dateTomorrow.toISOString().slice(0, -8);
                                        }}
                                    name="trial-create-expiry"
                            />
                        </div>
                    </div>
                </fieldset>

                {#if expiryType === 'unuse'}
                    <label for="newExpiryVal">Expire after how long without use (max 7 days):</label>
                    <input bind:value={expiryVal} id="newExpiryVal" type="number" min="1" required/>
                    <select id="newExpiryDenom" bind:value={expiryDenom} required>
                        <option value="minutes">Minutes</option>
                        <option value="hours">Hours</option>
                        <option value="days">Days</option>
                    </select>
                {/if}
                {#if expiryType === 'length'}
                    <label for="newExpiryVal">Expire after how long (max 4 weeks):</label>
                    <input bind:value={expiryVal} id="newExpiryVal" type="number" min="1" required/>
                    <select id="newExpiryDenom" bind:value={expiryDenom} required>
                        <option value="minutes">Minutes</option>
                        <option value="hours">Hours</option>
                        <option value="days">Days</option>
                        <option value="weeks">Weeks</option>
                    </select>
                {/if}
                {#if expiryType === 'date'}
                    <label for="newExpiryVal">Expire when (max 90 days from now):</label>
                    <input
                            type="datetime-local"
                            id="newExpiryVal"
                            bind:value={expiryVal}
                            min={dateTomorrow.toISOString().slice(0, -8)}
                            max={dateThreeMonths.toISOString().slice(0, -8)}
                            required
                    />
                {/if}
                <div>
                    <Button type="submit" id="newCodeConf" variant="raised">
                        <span class="material-icons">add_box</span> Create New Invite Code
                    </Button>
                </div>
            </form>

        {:else}
            <h3>Classroom Settings</h3>

            <h4>Pending Students</h4>
            {#if 'pending_students' in viewData && Array.isArray(viewData.pending_students) && viewData.pending_students.length > 0}
                <div style="display:flex; align-items: center; justify-content: center">
                    <input
                            class="roster-check"
                            type="checkbox"
                            bind:this={allSelCbPd}
                            on:click={toggleAllPending}
                    /> Select All
                </div>
                <div style="display: flex; justify-content: center">
                    <ul class="pending-list">
                        {#each viewData.pending_students as st, pIdx}
                            <li><input class="roster-check" type="checkbox"
                                       bind:checked={currentViewData.pendingSelectOptions[pIdx]}/>{st}</li>
                        {/each}
                    </ul>
                </div>
                <br>
                <p>{pendingSelectedCount > 0? pendingSelectedCount : "None"} selected...</p>
                <Button
                        variant="raised"
                        on:click={mailTaskAndRefresh("classes/dispatch_enroll_mail", {student_addresses: pendingSelectedKeys}, rCt => {
                               if(confirm(`Send a reminder to ${rCt} pending student(s)?`)) {
                                  return {};
                               }
                               return false;
                            }, "Reminder sent.", {}, reminderNotifAnchor, false)}
                        disabled={pendingSelectedCount < 1}
                >
                    <span class="material-icons">email</span> Send Email Reminder
                </Button>
                <Button
                        variant="raised"
                        on:click={postTaskAndRefresh("classes/uninvite", {students: pendingSelectedKeys}, () => {
                               if(confirm(`Uninvite ${pendingSelectedCount} pending student(s)?`)) {
                                  return {uninvite_confirmation: "UNINVITE"};
                               }
                               return false;
                            })}
                        disabled={pendingSelectedCount < 1}
                >
                    <span class="material-icons">playlist_remove</span> Uninvite
                </Button>

                <!-- Intended to supply mail result anchor from App -->
                <slot name="mailReminder" />

            {:else}
                <p>None for now.</p>
            {/if}

            <h4>Add New Students</h4>
            <form on:submit|preventDefault={mailTaskAndRefresh(
                   "classes/create_enrolls", {student_addresses: addStudentsField},
                   null, "Enrolled new students.", {do_mail: doMailField}, inviteNotifAnchor
                   )}
            >
                <label for="enrollAddStudentsField">Enter student emails to enroll (delimited by spaces):</label>
                <input
                        class="invite-entry"
                        placeholder="e.g. bhoneydew@wpi.edu beaker@gmail.com"
                        id="enrollAddStudentsField"
                        bind:value={addStudentsField}
                        type="text"
                        required
                />
                <div style="display: flex; align-items: center; justify-content: center">
                    <label for="doMail" style="display: inline-block; margin-right: 0.4em">Include an email invitation:</label>
                    <input class="invite-checkbox" id="doMail" type="checkbox" bind:checked={doMailField}/>
                </div>
                <p style="font-size: smaller; font-weight: bold; margin-top: 0.2em; margin-bottom: 1em">
                    (You can do this later if you'd like!)
                </p>
                <Button type="submit" id="trialAddConf" variant="raised">
                    <span class="material-icons">group_add</span> Enroll users
                </Button>
            </form>

            <!-- Intended to supply mail result anchor from App -->
            <slot name="mailInvite" />

        {/if}

        <h3>Data Management</h3>
        <Button id="teachingDL" variant="raised" on:click={() => dataDump()}>
            <span class="material-icons">school</span> Download teaching data as csv
        </Button>

        <!-- To ensure anonymity/IRB compliance, classes are currently not associated with research data. -->
        <!-- The below could be used for narrower CSV files if class IDs were safely associated with this data. -->
        <!--
        {#if isAdmin}
            <Button id="researchDL" variant="raised" on:click={() => dataDump(true)}>
                <span class="material-icons">biotech</span> Download research data as csv
            </Button>
        {/if}
        -->

        <Button
                variant="raised"
                on:click={postTaskAndRefresh(viewData.is_trial? "classes/delete_trial_class" : "classes/delete_class", {}, () => {
                       const pmtRes = prompt(
`CAUTION: Deleting this class will drop all students and wipe all associated teaching data.
This can't be undone!

Confirm the class name in the box below to permanently delete it.`
                       );

                       if(pmtRes) {
                          return {delete_confirmation: pmtRes.trim()};
                       }
                       return false;
                    }, "/")}
        >
            <span class="material-icons">delete_forever</span> Delete Class
        </Button>
        <br>
        <br>
        <a style="display: none" id="csvDownloadLink" href="" download/>

    {/await}

</div>


<style>
    .box {
        margin-top: 2em;
        margin-bottom: 1em;
        padding: 40px;
        border: 1px solid #323232;
        border-radius: .5rem;

        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        backdrop-filter: blur(1.4px) saturate(0.56) brightness(1.05);
    }

    .email-button {
        color: #333;
        background-color: #D7C7A1;
        border: none;

        padding: 0.4em 0.3em 0.3em 0.4em;

        border-radius: 5px;

        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        cursor: pointer;

        margin-left: 0.5em;
    }

    .email-button > * {
        font-size: 1.2em;
    }

    ul.roster-list {
        list-style: none;
    }

    .roster-list > li {
        width: 90%;
        text-align: left;
        background-color: #AC8B6468;

        padding: 1.5em;
        border-radius: 8px;
        margin-bottom: 0.5em;

        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        display: flex;
    }

    .roster-list > li.full-details {
        background-color: #43a04768;
    }

    .roster-list > li h4 {
        font-size: x-large;
        font-weight: bold;
        margin: 0.2em;

        display: flex;
        align-items: center;
    }

    ul.pending-list {
        list-style: none;
        width: 95%;
        max-width: 500px;

        padding: 0.5em;
        border-radius: 5px;

        background-color: #AC8B6468;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }

    ul.pending-list > li {
        display: flex;
        align-items: center;
    }

    .roster-check {
        height: 1em;
        width: 1.5em;
        accent-color: #43a047;

        margin: 0.2em;
    }

    .invite-code-big {
        font-size: xxx-large;
        font-weight: bold;

        margin: 0.2em;
    }

    .invite-code-big.expired {
        color: #59595999;
    }

    span.material-icons {
        margin-right: 0.15em;
    }

    h2 {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    h3 {
        margin-top: 3em;
    }

    h4 {
        margin-top: 2em;
        margin-bottom: 0.75em;
    }

    .invite-entry {
        display: block;
        width: 60vw;

        margin-left: auto;
        margin-right: auto;
    }

    .invite-checkbox {
        height: 1.5em;
        width: 1.5em;
        accent-color: #43a047;

        margin: 0.2em;
    }


</style>